import { useState } from 'react'
import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'

import Icon from '../../../../Icons'
import SelectField from '../../../../FormLegacy/FormFieldsV2/SelectField'
import TextField from '../../../../FormLegacy/FormFieldsV2/TextField'
import { LINK_REGEX } from '../../../../../helpers/constants'
import { serviceOptions } from '../../helpers'
import API from '../../../../../api/api'

const SocialLinkForm = ({
  handleCancel,
  previewData,
  refreshList,
  existingSocialServices,
  buildingId,
}) => {
  const { t } = useTranslation(['social-link', 'common'])
  const [isSubmitting, setSubmitting] = useState(false)
  const [errorMessage, setErrorMessage] = useState(null)
  const [linkTxt, setLinkTxt] = useState(previewData ? previewData.link : '')
  const [linkService, setLinkService] = useState(previewData ? previewData.service : null)

  const sendData = {
    buildingId,
    service: linkService,
    link: linkTxt,
  }

  const setInitialValues = () => {
    setLinkTxt('')
    setLinkService(null)
    setSubmitting(false)
  }

  const addSocialLink = () => {
    setSubmitting(true)
    try {
      API.addNewSocialLink(sendData).then(() => {
        refreshList(buildingId)
        setInitialValues()
        handleCancel()
      })
    } catch (e) {
      setErrorMessage(e)
    }
  }

  const updateSocialLink = () => {
    setSubmitting(true)
    try {
      API.updateSocialLink(sendData, previewData.id).then(() => {
        refreshList(buildingId)
        setInitialValues()
        handleCancel()
      })
    } catch (e) {
      setErrorMessage(e)
    }
  }

  const removeSocialLink = () => {
    setSubmitting(true)
    try {
      API.removeSocialLink(previewData.id, sendData.buildingId).then(() => {
        refreshList(buildingId)
        setInitialValues()
        handleCancel()
      })
    } catch (e) {
      setErrorMessage(e)
    }
  }

  const isServiceTypeAvailable =
    (!existingSocialServices.includes(linkService) && !previewData) || previewData
  const isValid = LINK_REGEX.test(linkTxt) && linkService && isServiceTypeAvailable

  return (
    <div className="social-link-form">
      <div className={`social-link-form__container ${isSubmitting ? 'is-disabled' : ''}`}>
        <div className="window-header">
          <div className="left-side">
            <div className="title">{t('social-link:form.title')}</div>
          </div>
          <div className="right-side">
            <div
              className="navi-button"
              onClick={() => {
                setInitialValues()
                handleCancel()
              }}
            >
              <Icon icon="cross" />
            </div>
          </div>
        </div>
        <div className="main-view">
          <div className="field-wrapper">
            <SelectField
              name={'linkService'}
              value={linkService}
              placeholder={t('social-link:form.selectServicePlaceholder')}
              options={serviceOptions}
              onChange={(e) => setLinkService(e.target.value)}
              disabled={isSubmitting}
            />
          </div>
          <div className="field-wrapper">
            <TextField
              name={'linkTxt'}
              placeholder={t('social-link:form.addLinkPlaceholder')}
              value={linkTxt}
              onChange={(e) => setLinkTxt(e.target.value)}
              autoComplete="new-password"
              disabled={isSubmitting}
              maxLength="255"
            />
          </div>
        </div>
        <div className="window-footer">
          <div className="error-message">
            {!isServiceTypeAvailable ? t('social-link:form.serviceTypeExistsError') : errorMessage}
          </div>
          <div className="footer-buttons">
            <button
              type="submit"
              className={`button button-black is-block ${isSubmitting ? 'is-loading' : ''}`}
              onClick={() => {
                setInitialValues()
                handleCancel()
              }}
              disabled={isSubmitting}
            >
              {t('common:actions.cancel')}
            </button>
            {previewData && (
              <button
                type="submit"
                className={`button button-black is-block ${isSubmitting ? 'is-loading' : ''}`}
                onClick={() => {
                  removeSocialLink()
                }}
                disabled={isSubmitting}
              >
                {t('social-link:form.removeButton')}
              </button>
            )}
            <button
              type="submit"
              className={`button button-primary is-block ${isSubmitting ? 'is-loading' : ''}`}
              onClick={previewData ? updateSocialLink : addSocialLink}
              disabled={isSubmitting || !isValid}
            >
              {t('common:actions.save')}
            </button>
          </div>
        </div>
      </div>
    </div>
  )
}

SocialLinkForm.propTypes = {
  handleCancel: PropTypes.func,
  refreshList: PropTypes.func,
  previewData: PropTypes.object,
  existingSocialServices: PropTypes.array,
  buildingId: PropTypes.number,
}

export default SocialLinkForm
